<script setup lang="ts">
defineProps<{ text: string | null }>();
</script>

<template>
  <div class="fixed bottom-9 left-1/2 -translate-x-1/2 z-30 pointer-events-none select-none">
    <Transition
      mode="out-in"
      enter-active-class="transition-all duration-700 ease-out"
      enter-from-class="opacity-0 translate-y-3"
      leave-active-class="transition-all duration-[400ms] ease-in"
      leave-to-class="opacity-0"
    >
      <div
        v-if="text"
        :key="text"
        class="hint-container relative inline-flex items-center justify-center text-center"
      >
        <div class="fog-backdrop" aria-hidden="true"></div>
        <span
          class="relative z-10 m-0 font-medium uppercase tracking-[0.25em] sm:tracking-[0.32em] text-[clamp(14px,1.6vw,18px)] text-[var(--color-dark,#491214)] whitespace-nowrap [text-shadow:_0_0_12px_rgba(255,255,255,0.85)]"
        >
          {{ text }}
        </span>
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.hint-container {
  transform: translateZ(0);
}

.fog-backdrop {
  position: absolute;
  inset: -16px -36px;
  border-radius: 9999px;
  background:
    radial-gradient(
      ellipse 65% 55% at 50% 50%,
      rgba(255, 255, 255, 0.9) 0%,
      rgba(255, 255, 255, 0.78) 30%,
      rgba(255, 255, 255, 0.4) 55%,
      rgba(255, 255, 255, 0.1) 75%,
      rgba(255, 255, 255, 0) 90%
    ),
    radial-gradient(
      ellipse 85% 75% at 50% 50%,
      rgba(255, 255, 255, 0.35) 0%,
      rgba(255, 255, 255, 0.18) 45%,
      rgba(255, 255, 255, 0.05) 70%,
      rgba(255, 255, 255, 0.01) 88%,
      rgba(255, 255, 255, 0) 100%
    );
  pointer-events: none;
  transform: translateZ(0);
}

@media (min-width: 640px) {
  .fog-backdrop {
    inset: -20px -48px;
  }
}
</style>